import { render, staticRenderFns } from "./ResourceLogins.vue?vue&type=template&id=2a8515e4&scoped=true"
import script from "./ResourceLogins.vue?vue&type=script&lang=js"
export * from "./ResourceLogins.vue?vue&type=script&lang=js"
import style0 from "./ResourceLogins.vue?vue&type=style&index=0&id=2a8515e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8515e4",
  null
  
)

export default component.exports